<template>
  <div v-if="body_show" class="bodys">
    <div class="task-title">
      项目彩蛋
    </div>
    <div class="task_f pj2_2">
      <h2><span>恭喜你解锁了本周的福利彩蛋！</span>你可以从下面的专业测评工具中，选出最适合自己的那款，以更好的发掘自身的<span>优势、个性、驱动力</span>。增进自我觉察，找准发展路径。</h2>
      <h2 style="margin-top: 20px">阿里巴巴、中国人民银行等超过9000家企业在人才选拔、盘点、晋升时都在使用这套测评体系，其中包括800多家中外500强企业。这套评估体系首次面向个人开放，是市面上个人进行<span>目标职位测评</span>、获取<span>竞争力专业分析</span>的唯一入口。</h2>
    </div>
    <!-- 请选择适合您的测评 -->
    <div class="tendency_learn">
      <h1>请选择适合您的测评</h1>
      <van-radio-group class="radio_group" v-for="(item,index) in data" :key="index" v-model="radio">
        <van-radio :name="item.activityid">
          <h2 class="clearfix">{{item.aliasname}}</h2>
          <p class="clearfix">{{item.pmqdetail}}</p>
        </van-radio>
      </van-radio-group>
    </div>
    <!-- 提交 -->
    <div class="task-footer">
      <div @click="submitData" :class="[isAdopt ? 'active' : '', 'submit-task']">提交</div>
    </div>
  </div>
</template>
<script>
import {
  coursepmq,
  createcoursepmq
} from "@/api/course"
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        data: {},
        body_show: false,
        radio: '',
        isAdopt: false
      }
    },
    watch: {
      radio(newValue, oldValue) {
          if (this.radio.length) {
            this.isAdopt = true
          }
      },
    },
    methods: {
      pullData() {
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        this.cid = this.$route.query.cid;
        coursepmq({
            cid: this.cid
          })
          .then((data) => {
            this.$toast.clear();
            this.body_show = true;
            this.data = data;

          })

      },
      submitData() {
        if (!this.isAdopt) {
          return
        }
        // 提交
        let q = this.$route.query;
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        createcoursepmq({
            cid: q.cid,
            activityid: this.radio
          })
          .then((data) => {
            let d = data;
            location.href = d.pmqhref
          })
      },
    },
    created() {
      this.pullData();
      shareCon("course",this);
    }
}
</script>
<style lang="scss">
@import "@s/remChange.scss";
.task-title {
  text-align: center;
  font-size: 0.48rem;
  color: #333;
  font-weight: bold;
}

.bodys {
  padding: 0.4rem 0
}

.task_f {
  padding: 0 changeRem(.6)+px;
  margin: 0 auto;
  margin-top: changeRem(.8)+px;
  text-align: left;
  position: relative;
  h2 {
    color: #333333;
    font-size: changeRem(.64)+px;
    line-height: changeRem(.84)+px;
    text-align: justify;
    span {
      color: rgb(235, 80, 50)
    }
  }
}

.tendency_learn {
  color: #333333;
  padding: 0 30px;
  margin-top: 20px;
}

.tendency_learn h1 {
  font-size: 32px;
  text-align: left;
  margin-bottom: 20px
}

.tendency_learn h2 {
  line-height: 34px;
  color: #EB5032;
  font-size: 32px;
}

.tendency_learn .grouping.nmbt {
  margin-top: 33px;
}

.tendency_learn .radio_group {
  margin-bottom: 30px;
}

.tendency_learn .radio_group:last-child {
  margin-bottom: 0;
}

.tendency_learn .radio_group .van-radio__icon {
  height: auto;
}

.tendency_learn .radio_group .van-radio__icon .van-icon {
  width: 40px;
  height: 40px;
  line-height: 40px;
  background-image: url(../../../assets/radio_.png);
  background-size: 100% 100%;
  border-color: transparent;
  background-color: transparent;
}

.tendency_learn .radio_group .van-radio__icon .van-icon:before {
  content: '';
}

.tendency_learn .radio_group .van-radio__icon.van-radio__icon--checked .van-icon.van-icon-success {
  background-image: url(../../../assets/radio_active.png);
}

.tendency_learn .radio_group .van-radio__label {
  line-height: 42px;
  width: 618px;
  margin-left: 30px;
  font-size: 32px;
}

.task-footer {
  padding-top: 1.06667rem;
  .submit-task {
    margin-bottom: 1.06667rem;
    color: #fff;
    font-size: 0.45333rem;
    text-align: center;
    width: 2.32rem;
    height: 0.88rem;
    line-height: 0.88rem;
    background: #cccccc;
    border-radius: 0.44rem;
    margin: 0 auto;
  }
  .submit-task.active {
    background-color: #EB5032;
  }
}
</style>
